(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.reset();
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waiiqi-contact-editorial"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  if(!event.target.closest('[data-wq-editorial-ask]'))return;
  var launcher=document.querySelector('[data-waiiqi-concierge] [data-concierge-open]');
  if(launcher){launcher.click();}else{window.location.href='mailto:hello@waiiqi.com';}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waiiqi-island-weather"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialize(scope = document) {
      scope.querySelectorAll('[data-island-weather]').forEach(root => {
        if (root.dataset.ready) return;
        root.dataset.ready = 'true';
        const labels = JSON.parse(root.querySelector('[data-island-labels]').textContent);
        const reading = root.querySelector('[data-island-reading]'), observed = root.querySelector('[data-island-observed]'), issued = root.querySelector('[data-island-issued]'), status = root.querySelector('[data-island-status]'), periods = root.querySelector('[data-island-periods]'), units = root.querySelector('[data-island-units]');
        let observation = null, forecast = null, celsius = true, busy = false, visible = false, lastAttempt = 0, controller;
        const formatTime = date => new Intl.DateTimeFormat(document.documentElement.lang, {timeZone:'Pacific/Honolulu', month:'short', day:'numeric', hour:'numeric', minute:'2-digit'}).format(new Date(date)) + ' HST';
        const degrees = value => Math.round(celsius ? value : value * 9 / 5 + 32) + '°' + (celsius ? 'C' : 'F');
        const fresh = (date, age) => Number.isFinite(Date.parse(date)) && Date.now() - Date.parse(date) >= -300000 && Date.now() - Date.parse(date) < age;
        const render = () => {
          if (observation && !fresh(observation.timestamp, 7200000)) observation = null;
          if (forecast && !fresh(forecast.updateTime, 86400000)) forecast = null;
          reading.textContent = observation ? degrees(observation.temperature.value) + ' · ' + formatTime(observation.timestamp) : labels.unavailable;
          observed.textContent = observation ? labels.observation + ' · ' + formatTime(observation.timestamp) : labels.unavailable;
          periods.replaceChildren();
          (forecast?.periods || []).filter(period => Date.parse(period.endTime) > Date.now()).slice(0, 3).forEach(period => {
            const row = document.createElement('div'), title = document.createElement('strong'), temperature = document.createElement('span'), text = document.createElement('p');
            row.className = 'waiiqi-island__period';
            title.textContent = new Intl.DateTimeFormat(document.documentElement.lang, {timeZone:'Pacific/Honolulu', weekday:'short', hour:'numeric'}).format(new Date(period.startTime));
            temperature.textContent = degrees(period.temperatureUnit === 'F' ? (period.temperature - 32) * 5 / 9 : period.temperature);
            text.textContent = period.shortForecast; text.lang = 'en'; row.append(title, temperature, text); periods.append(row);
          });
          issued.textContent = forecast ? labels.issued + ' · ' + formatTime(forecast.updateTime) : '';
          status.textContent = forecast ? '' : labels.error;
          units.textContent = celsius ? '°C → °F' : '°F → °C';
        };
        const refresh = async () => {
          if (busy || document.hidden) return;
          busy = true; lastAttempt = Date.now(); controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 12000);
          const get = async url => {
            const target = new URL(url);
            if (target.origin !== 'https://api.weather.gov') throw Error('source');
            const response = await fetch(target, {signal:controller.signal, credentials:'omit', cache:'no-cache'});
            if (!response.ok) throw Error('weather');
            return (await response.json()).properties;
          };
          const results = await Promise.allSettled([
            get('https://api.weather.gov/stations/PHNL/observations/latest'),
            get('https://api.weather.gov/points/21.2793,-157.829').then(point => get(point.forecast))
          ]);
          if (!root.isConnected) { clearTimeout(timeout); return; }
          const candidate = results[0].status === 'fulfilled' ? results[0].value : null;
          observation = candidate && fresh(candidate.timestamp,7200000) && candidate.temperature?.unitCode === 'wmoUnit:degC' && Number.isFinite(candidate.temperature.value) ? candidate : null;
          const nextForecast = results[1].status === 'fulfilled' ? results[1].value : null;
          forecast = nextForecast && fresh(nextForecast.updateTime,86400000) && Array.isArray(nextForecast.periods) && nextForecast.periods.some(p => Date.parse(p.endTime) > Date.now()) && nextForecast.periods.every(p => Number.isFinite(p.temperature) && ['C','F'].includes(p.temperatureUnit) && Number.isFinite(Date.parse(p.startTime))) ? nextForecast : null;
          clearTimeout(timeout); busy = false; render();
        };
        units.addEventListener('click', () => { celsius = !celsius; render(); });
        root.querySelector('details').addEventListener('toggle', () => { if (root.querySelector('details').open && Date.now() - lastAttempt > 900000) refresh(); });
        const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; if (visible && Date.now() - lastAttempt > 900000) refresh(); }, {rootMargin:'200px'});
        observer.observe(root);
        const visibility = () => { if (visible && !document.hidden) { if (lastAttempt) render(); if (Date.now() - lastAttempt > 900000) refresh(); } };
        document.addEventListener('visibilitychange', visibility);
        const interval = setInterval(() => {
          if (!root.isConnected) { clearInterval(interval); observer.disconnect(); controller?.abort(); document.removeEventListener('visibilitychange',visibility); return; }
          if (lastAttempt && !busy) render();
          if (visible && !document.hidden && Date.now() - lastAttempt > 900000) refresh();
        }, 60000);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true}); else initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waiiqi-ocean-atlas"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialize(scope = document) {
      scope.querySelectorAll('[data-ocean-atlas]').forEach(root => {
        if (root.dataset.ready) return;
        root.dataset.ready = 'true';
        const stops = [...root.querySelectorAll('[data-atlas-stop]')], continents = ['north_america','south_america','europe','africa','asia','oceania','antarctica'];
        const labels = JSON.parse(root.querySelector('[data-atlas-labels]').textContent), dialog = root.querySelector('[data-atlas-dialog]'), player = root.querySelector('[data-atlas-player]'), status = root.querySelector('[data-atlas-modal-status]'), watch = root.querySelector('[data-atlas-watch]');
        let featured, opener, refreshImage, previousOverflow, dateKey = '';
        const localTime = zone => { try { return new Intl.DateTimeFormat(document.documentElement.lang,{timeZone:zone,hour:'2-digit',minute:'2-digit'}).format(new Date()); } catch { return '—'; } };
        const update = () => {
          const parts = new Intl.DateTimeFormat('en-US',{timeZone:'Pacific/Honolulu',year:'numeric',month:'2-digit',day:'2-digit',weekday:'short'}).formatToParts(new Date());
          const date = Object.fromEntries(parts.map(part => [part.type,part.value])), key = date.year + '-' + date.month + '-' + date.day;
          if (key !== dateKey) {
            dateKey = key;
            const monthIndex = (Number(date.year) - 2026) * 12 + Number(date.month) - 9;
            const today = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].indexOf(date.weekday);
            stops.forEach(stop => { stop.hidden = true; stop.removeAttribute('aria-current'); });
            continents.forEach((continent,index) => {
              const pool = stops.filter(stop => stop.dataset.continent === continent);
              if (!pool.length) return;
              const stop = pool[((monthIndex % pool.length) + pool.length) % pool.length];
              stop.hidden = false; stop.style.order = index;
              stop.querySelector('[data-atlas-day]').textContent = new Intl.DateTimeFormat(document.documentElement.lang,{weekday:'short',timeZone:'UTC'}).format(new Date(Date.UTC(2026,8,14 + index)));
              if (index === today) { featured = stop; stop.setAttribute('aria-current','date'); }
            });
            featured ||= stops.find(stop => !stop.hidden);
            if (featured) { root.querySelector('[data-atlas-name]').textContent = featured.dataset.name; root.querySelector('[data-atlas-continent]').textContent = featured.dataset.continentLabel; watch.href = featured.href; }
            root.querySelector('[data-atlas-edition]').textContent = labels.edition + ' · ' + new Intl.DateTimeFormat(document.documentElement.lang,{timeZone:'Pacific/Honolulu',month:'long',year:'numeric'}).format(new Date());
          }
          if (featured) root.querySelector('[data-atlas-time]').textContent = localTime(featured.dataset.zone);
        };
        const open = (stop, trigger) => {
          if (!stop || !dialog.showModal) return false;
          opener = trigger; status.textContent = ''; player.replaceChildren(); clearInterval(refreshImage);
          const still = stop.dataset.still, isStill = Boolean(still);
          root.querySelector('[data-atlas-modal-title]').textContent = stop.dataset.name;
          root.querySelector('[data-atlas-provider]').textContent = stop.dataset.provider;
          root.querySelector('[data-atlas-source]').href = stop.href;
          root.querySelector('[data-atlas-modal-type]').textContent = isStill ? labels.still : labels.video;
          root.querySelector('[data-atlas-modal-note]').textContent = isStill ? labels.still_note : labels.video_note;
          previousOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; dialog.showModal(); root.querySelector('[data-atlas-close]').focus();
          if (stop.dataset.approved !== 'true') { status.textContent = labels.unavailable; return true; }
          if (isStill && /^https:\/\/gml\.noaa\.gov\/webdata\/spo\/webcam\/[a-z0-9_.-]+\.jpg$/i.test(still)) {
            const load = () => {
              if (document.hidden || !dialog.open) return;
              const image = new Image(); image.alt = stop.dataset.name + ' · ' + labels.still; image.referrerPolicy = 'no-referrer';
              status.textContent = labels.loading;
              image.onload = () => { if (dialog.open && player.dataset.source === still) { player.replaceChildren(image); status.textContent = ''; } };
              image.onerror = () => { if (dialog.open && player.dataset.source === still) { player.replaceChildren(); status.textContent = labels.unavailable; } };
              image.src = still + '?waiiqi_refresh=' + Math.floor(Date.now()/900000);
            };
            player.dataset.source = still; load(); refreshImage = setInterval(load,900000);
          } else if (/^[A-Za-z0-9_-]{11}$/.test(stop.dataset.video)) {
            const frame = document.createElement('iframe'); frame.title = stop.dataset.name + ' · ' + stop.dataset.provider; frame.src = 'https://www.youtube-nocookie.com/embed/' + stop.dataset.video + '?playsinline=1'; frame.allow = 'fullscreen; picture-in-picture; encrypted-media'; frame.allowFullscreen = true; frame.referrerPolicy = 'strict-origin-when-cross-origin'; player.append(frame);
          } else { status.textContent = labels.unavailable; }
          return true;
        };
        const normalClick = event => !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0;
        stops.forEach(stop => stop.addEventListener('click',event => { if (normalClick(event) && open(stop,stop)) event.preventDefault(); }));
        watch.addEventListener('click',event => { if (normalClick(event) && open(featured,watch)) event.preventDefault(); });
        root.querySelector('[data-atlas-close]').addEventListener('click',() => dialog.close());
        dialog.addEventListener('click',event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
        dialog.addEventListener('close',() => { player.replaceChildren(); delete player.dataset.source; clearInterval(refreshImage); document.documentElement.style.overflow = previousOverflow; opener?.focus({preventScroll:true}); });
        const visibility = () => { if (!document.hidden) update(); };
        document.addEventListener('visibilitychange',visibility); update();
        const timer = setInterval(() => { if (!root.isConnected) { clearInterval(timer); clearInterval(refreshImage); document.removeEventListener('visibilitychange',visibility); if (dialog.open) { document.documentElement.style.overflow = previousOverflow; dialog.close(); } return; } if (!document.hidden) update(); },30000);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initialize(),{once:true}); else initialize();
    document.addEventListener('shopify:section:load',event => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waiiqi-ocean-window"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialize(scope=document) {
      scope.querySelectorAll('[data-ocean-window]').forEach(root => {
        if(root.dataset.ready) return; root.dataset.ready='true';
        const stations=[...root.querySelectorAll('[data-ocean-station]')],choices=[...root.querySelectorAll('[data-ocean-choice]')];
        const select=index=>{stations.forEach((station,i)=>{station.hidden=i!==index;if(i!==index)station.querySelector('[data-ocean-player]')?.replaceChildren();});choices.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));};
        const updateClocks=()=>stations.forEach(station=>{try{station.querySelector('[data-ocean-time]').textContent=new Intl.DateTimeFormat(document.documentElement.lang,{timeZone:station.dataset.zone,hour:'2-digit',minute:'2-digit'}).format(new Date());}catch{}});
        choices.forEach((button,i)=>button.addEventListener('click',()=>{select(i);updateClocks();}));
        if(stations.length) select(Math.floor(Date.now()/86400000)%stations.length);updateClocks();
        root.addEventListener('focusin',updateClocks);root.addEventListener('pointerenter',updateClocks);
        root.querySelectorAll('[data-ocean-embed]').forEach(button=>button.addEventListener('click',()=>{if(!/^[a-zA-Z0-9_-]{11}$/.test(button.dataset.oceanEmbed))return;const frame=document.createElement('iframe');frame.src='https://www.youtube-nocookie.com/embed/'+button.dataset.oceanEmbed;frame.title=button.closest('article').querySelector('h3').textContent;frame.allow='fullscreen; picture-in-picture';frame.referrerPolicy='strict-origin-when-cross-origin';button.closest('article').querySelector('[data-ocean-player]').replaceChildren(frame);}));
        const labels=JSON.parse(root.querySelector('[data-ocean-labels]').textContent),load=root.querySelector('[data-weather-load]'),status=root.querySelector('[data-weather-status]'),units=root.querySelector('[data-weather-unit]');let data=null,celsius=true;
        const render=()=>{const container=root.querySelector('[data-weather-periods]');container.replaceChildren();data.periods.filter(p=>Date.parse(p.endTime)>Date.now()).slice(0,3).forEach(p=>{const row=document.createElement('div');row.className='waiiqi-ocean__period';const title=document.createElement('strong'),temp=document.createElement('span'),copy=document.createElement('p');title.textContent=new Intl.DateTimeFormat(document.documentElement.lang,{timeZone:'Pacific/Honolulu',weekday:'short',hour:'numeric'}).format(new Date(p.startTime));const degrees=p.temperatureUnit==='F'?(p.temperature-32)*5/9:p.temperature;temp.textContent=Math.round(celsius?degrees:degrees*9/5+32)+'°'+(celsius?'C':'F');copy.textContent=p.shortForecast;copy.lang='en';row.append(title,temp,copy);container.append(row);});root.querySelector('[data-weather-issued]').textContent=labels.issued+' · '+new Intl.DateTimeFormat(document.documentElement.lang,{timeZone:'Pacific/Honolulu',month:'short',day:'numeric',hour:'numeric',minute:'2-digit'}).format(new Date(data.updated))+' HST';units.hidden=false;units.textContent=celsius?'°C → °F':'°F → °C';};
        units.addEventListener('click',()=>{celsius=!celsius;render();});
        load.addEventListener('click',async()=>{load.disabled=true;status.textContent=labels.loading;const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);try{const get=async url=>{const target=new URL(url);if(target.origin!=='https://api.weather.gov')throw Error('source');const r=await fetch(target,{signal:controller.signal,credentials:'omit'});if(!r.ok)throw Error('forecast');return r.json();};const point=await get('https://api.weather.gov/points/21.2793,-157.829');const result=await get(point.properties.forecast);const candidate={periods:result.properties.periods,updated:result.properties.updateTime};if(!Array.isArray(candidate.periods)||!candidate.periods.some(p=>Date.parse(p.endTime)>Date.now())||!Number.isFinite(Date.parse(candidate.updated))||Date.now()-Date.parse(candidate.updated)>86400000)throw Error('stale');data=candidate;render();status.textContent='';}catch{root.querySelector('[data-weather-periods]').replaceChildren();root.querySelector('[data-weather-issued]').textContent='';units.hidden=true;status.textContent=labels.error;}finally{clearTimeout(timer);load.disabled=false;}});
      });
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true});else initialize();document.addEventListener('shopify:section:load',event=>initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
